'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.borderTopWidth = exports.borderTopStyle = exports.borderTopColor = exports.borderTop = exports.borderRightWidth = exports.borderRightStyle = exports.borderRightColor = exports.borderRight = exports.borderLeftWidth = exports.borderLeftStyle = exports.borderLeftColor = exports.borderLeft = exports.borderBottomWidth = exports.borderBottomStyle = exports.borderBottomColor = exports.borderBottom = exports.borderBottomLeftRadius = exports.borderTopLeftRadius = exports.borderBottomRightRadius = exports.borderTopRightRadius = exports.borderRadius = exports.borderWidth = exports.borderStyle = exports.borderColor = exports.border = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    ', ';\n  '], ['\n    ', ';\n  ']);

var _core = require('@emotion/core');

var _ = require('../../');

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var border = exports.border = function border(_ref) {
  var border = _ref.border;
  return border && (0, _core.css)(_templateObject, _2.default.responsive('border')(border));
};

var borderColor = exports.borderColor = function borderColor(_ref2) {
  var borderColor = _ref2.borderColor;
  return borderColor && (0, _core.css)(_templateObject, _2.default.responsive('border-color')(borderColor));
};

var borderStyle = exports.borderStyle = function borderStyle(_ref3) {
  var borderStyle = _ref3.borderStyle;
  return borderStyle && (0, _core.css)(_templateObject, _2.default.responsive('border-style')(borderStyle));
};

var borderWidth = exports.borderWidth = function borderWidth(_ref4) {
  var borderWidth = _ref4.borderWidth;
  return borderWidth && (0, _core.css)(_templateObject, _2.default.responsive('border-width')(borderWidth));
};

var borderRadius = exports.borderRadius = function borderRadius(_ref5) {
  var borderRadius = _ref5.borderRadius;
  return borderRadius && (0, _core.css)(_templateObject, _2.default.responsive('border-radius')(borderRadius));
};

var borderTopRightRadius = exports.borderTopRightRadius = function borderTopRightRadius(_ref6) {
  var borderTopRightRadius = _ref6.borderTopRightRadius;
  return borderTopRightRadius && (0, _core.css)(_templateObject, _2.default.responsive('border-top-right-radius')(borderTopRightRadius));
};

var borderBottomRightRadius = exports.borderBottomRightRadius = function borderBottomRightRadius(_ref7) {
  var borderBottomRightRadius = _ref7.borderBottomRightRadius;
  return borderBottomRightRadius && (0, _core.css)(_templateObject, _2.default.responsive('border-bottom-right-radius')(borderBottomRightRadius));
};

var borderTopLeftRadius = exports.borderTopLeftRadius = function borderTopLeftRadius(_ref8) {
  var borderTopLeftRadius = _ref8.borderTopLeftRadius;
  return borderTopLeftRadius && (0, _core.css)(_templateObject, _2.default.responsive('border-top-left-radius')(borderTopLeftRadius));
};

var borderBottomLeftRadius = exports.borderBottomLeftRadius = function borderBottomLeftRadius(_ref9) {
  var borderBottomLeftRadius = _ref9.borderBottomLeftRadius;
  return borderBottomLeftRadius && (0, _core.css)(_templateObject, _2.default.responsive('border-bottom-left-radius')(borderBottomLeftRadius));
};

var borderBottom = exports.borderBottom = function borderBottom(_ref10) {
  var borderBottom = _ref10.borderBottom;
  return borderBottom && (0, _core.css)(_templateObject, _2.default.responsive('border-bottom')(borderBottom));
};

var borderBottomColor = exports.borderBottomColor = function borderBottomColor(_ref11) {
  var borderBottomColor = _ref11.borderBottomColor;
  return borderBottomColor && (0, _core.css)(_templateObject, _2.default.responsive('border-bottom-color')(borderBottomColor));
};

var borderBottomStyle = exports.borderBottomStyle = function borderBottomStyle(_ref12) {
  var borderBottomStyle = _ref12.borderBottomStyle;
  return borderBottomStyle && (0, _core.css)(_templateObject, _2.default.responsive('border-bottom-color')(borderBottomStyle));
};

var borderBottomWidth = exports.borderBottomWidth = function borderBottomWidth(_ref13) {
  var borderBottomWidth = _ref13.borderBottomWidth;
  return borderBottomWidth && (0, _core.css)(_templateObject, _2.default.responsive('border-bottom-color')(borderBottomWidth));
};

var borderLeft = exports.borderLeft = function borderLeft(_ref14) {
  var borderLeft = _ref14.borderLeft;
  return borderLeft && (0, _core.css)(_templateObject, _2.default.responsive('border-left')(borderLeft));
};

var borderLeftColor = exports.borderLeftColor = function borderLeftColor(_ref15) {
  var borderLeftColor = _ref15.borderLeftColor;
  return borderLeftColor && (0, _core.css)(_templateObject, _2.default.responsive('border-left-color')(borderLeftColor));
};

var borderLeftStyle = exports.borderLeftStyle = function borderLeftStyle(_ref16) {
  var borderLeftStyle = _ref16.borderLeftStyle;
  return borderLeftStyle && (0, _core.css)(_templateObject, _2.default.responsive('border-left-style')(borderLeftStyle));
};

var borderLeftWidth = exports.borderLeftWidth = function borderLeftWidth(_ref17) {
  var borderLeftWidth = _ref17.borderLeftWidth;
  return borderLeftWidth && (0, _core.css)(_templateObject, _2.default.responsive('border-left-width')(borderLeftWidth));
};

var borderRight = exports.borderRight = function borderRight(_ref18) {
  var borderRight = _ref18.borderRight;
  return borderRight && (0, _core.css)(_templateObject, _2.default.responsive('border-right')(borderRight));
};

var borderRightColor = exports.borderRightColor = function borderRightColor(_ref19) {
  var borderRightColor = _ref19.borderRightColor;
  return borderRightColor && (0, _core.css)(_templateObject, _2.default.responsive('border-right-color')(borderRightColor));
};

var borderRightStyle = exports.borderRightStyle = function borderRightStyle(_ref20) {
  var borderRightStyle = _ref20.borderRightStyle;
  return borderRightStyle && (0, _core.css)(_templateObject, _2.default.responsive('border-right-style')(borderRightStyle));
};

var borderRightWidth = exports.borderRightWidth = function borderRightWidth(_ref21) {
  var borderRightWidth = _ref21.borderRightWidth;
  return borderRightWidth && (0, _core.css)(_templateObject, _2.default.responsive('border-right-width')(borderRightWidth));
};

var borderTop = exports.borderTop = function borderTop(_ref22) {
  var borderTop = _ref22.borderTop;
  return borderTop && (0, _core.css)(_templateObject, _2.default.responsive('border-top')(borderTop));
};

var borderTopColor = exports.borderTopColor = function borderTopColor(_ref23) {
  var borderTopColor = _ref23.borderTopColor;
  return borderTopColor && (0, _core.css)(_templateObject, _2.default.responsive('border-top-color')(borderTopColor));
};

var borderTopStyle = exports.borderTopStyle = function borderTopStyle(_ref24) {
  var borderTopStyle = _ref24.borderTopStyle;
  return borderTopStyle && (0, _core.css)(_templateObject, _2.default.responsive('border-top-style')(borderTopStyle));
};

var borderTopWidth = exports.borderTopWidth = function borderTopWidth(_ref25) {
  var borderTopWidth = _ref25.borderTopWidth;
  return borderTopWidth && (0, _core.css)(_templateObject, _2.default.responsive('border-top-width')(borderTopWidth));
};